document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-marquee__track').forEach(function (track) {
    var viewport = track.closest('.custom-marquee__viewport');
    var firstGroup = track.querySelector('.custom-marquee__group');
    if (!viewport || !firstGroup) return;

    var templateHTML = firstGroup.outerHTML;

    function addGroup(hidden) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = templateHTML;
      var groupEl = wrapper.firstElementChild;
      if (hidden) {
        groupEl.setAttribute('aria-hidden', 'true');
      }
      track.appendChild(groupEl);
    }

    function rebuild() {
      track.innerHTML = '';
      addGroup(false); // real, accessible copy
      addGroup(true); // duplicate for the seamless loop

      var containerWidth = viewport.clientWidth;
      var safety = 0;

      // Keep adding duplicate groups until there's enough content to loop
      // seamlessly, no matter how few logos were added in the theme editor.
      while (track.scrollWidth < containerWidth * 2 && safety < 30) {
        addGroup(true);
        safety++;
      }

      // The 50% translateX loop only works cleanly with an even number of
      // groups (so both halves are identical), so pad by one more if needed.
      var groupCount = track.querySelectorAll('.custom-marquee__group').length;
      if (groupCount % 2 !== 0) {
        addGroup(true);
      }
    }

    var images = track.querySelectorAll('img');
    var pending = images.length;

    if (pending === 0) {
      rebuild();
      return;
    }

    function onImageDone() {
      pending--;
      if (pending <= 0) {
        rebuild();
      }
    }

    images.forEach(function (img) {
      if (img.complete) {
        onImageDone();
      } else {
        img.addEventListener('load', onImageDone, { once: true });
        img.addEventListener('error', onImageDone, { once: true });
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(rebuild, 200);
    });
  });
});